import React from 'react';
import { Play, ExternalLink } from 'lucide-react';

// YouTube thumbnail URLs are now generated dynamically from video IDs

// Discord Icon Component
const DiscordIcon = ({ className }: { className?: string }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);






interface VideoThumbnail {
  id: string;
  title: string;
  thumbnail: string;
  url: string;
  duration: string;
  views: string;
  attribution: string;
}

export function SocialMedia() {
  const videoData: VideoThumbnail[] = [
    {
      id: '1',
      title: 'Goosebumps Dead of Night - Horror Gaming Experience',
      thumbnail: 'https://img.youtube.com/vi/nYM0pR2Kyik/maxresdefault.jpg',
      url: 'https://youtu.be/nYM0pR2Kyik?si=cR3bEA2Ht6qW334L',
      duration: '18:26',
      views: '1.4M',
      attribution: 'Daylins Funhouse'
    },
    {
      id: '2',
      title: 'GOOSEBUMPS DEAD OF NIGHT.. | Fan Choice FRIGHTday',
      thumbnail: 'https://img.youtube.com/vi/QcISSB6W2HI/maxresdefault.jpg',
      url: 'https://youtu.be/QcISSB6W2HI?si=3Nu3XOgCgz204AZ4',
      duration: '25:42',
      views: '1.8M',
      attribution: 'Thinknoodles'
    },
    {
      id: '3',
      title: 'WEREWOLF KNOCKED OFF MIKE\'s HEAD 🎃@AHHH!@#%👻! GOOSEBUMPS NIGHT OF JUMP SCARES #2 (w/ FGTEEV Chase)',
      thumbnail: 'https://img.youtube.com/vi/R9SY5hBRPgQ/maxresdefault.jpg',
      url: 'https://youtu.be/R9SY5hBRPgQ?si=Xrmhhjq5qK6CNpeL',
      duration: '13:25',
      views: '43M',
      attribution: 'FGTeeV'
    },
    {
      id: '4',
      title: 'HORRIBLE NIGHT WITH LIVING DOLLS ► Goosebumps Dead of Night',
      thumbnail: 'https://img.youtube.com/vi/5tobMevFLkg/maxresdefault.jpg',
      url: 'https://youtu.be/5tobMevFLkg?si=b2tJAdwPIcT1cQmg',
      duration: '35:19',
      views: '1.1M',
      attribution: 'Tilka Play'
    },
    {
      id: '5',
      title: 'Goosebumps Night of Scares App Store',
      thumbnail: 'https://img.youtube.com/vi/PZqyQStvBzw/hqdefault.jpg',
      url: 'https://youtu.be/PZqyQStvBzw?si=WFu8GP3MShssfbba',
      duration: '0:29',
      views: '14M',
      attribution: 'Cosmic Forces'
    }
  ];

  const handleVideoClick = (url: string) => {
    if (url !== '#') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="social-media" className="py-20 relative overflow-hidden" style={{
      background: `linear-gradient(135deg, #8d4568 0%, #a85680 25%, #8d4568 50%, #734057 75%, #8d4568 100%)`
    }}>
      {/* Cyberpunk Grid Background */}
      <div className="absolute inset-0">
        {/* Base grid pattern adapted for pink background */}
        <div className="absolute inset-0 opacity-40">
          <div 
            className="w-full h-full"
            style={{
              backgroundImage: `
                linear-gradient(rgba(34, 211, 238, 0.15) 1px, transparent 1px),
                linear-gradient(90deg, rgba(34, 211, 238, 0.15) 1px, transparent 1px),
                linear-gradient(rgba(168, 85, 247, 0.1) 1px, transparent 1px),
                linear-gradient(90deg, rgba(168, 85, 247, 0.1) 1px, transparent 1px)
              `,
              backgroundSize: '60px 60px, 60px 60px, 20px 20px, 20px 20px',
              backgroundPosition: '0 0, 0 0, 0 0, 0 0'
            }}
          ></div>
        </div>

        {/* Enhanced neon circuit patterns for pink background */}
        <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-r from-transparent via-cyan-300/25 to-transparent transform -skew-y-1 shadow-lg shadow-cyan-400/20"></div>
        <div className="absolute bottom-0 right-0 w-full h-32 bg-gradient-to-l from-transparent via-orange-300/25 to-transparent transform skew-y-1 shadow-lg shadow-orange-400/20"></div>
        
        {/* Glowing orbs adapted for pink background */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-cyan-400/20 to-purple-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gradient-to-r from-purple-400/20 to-orange-400/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-cyan-300/15 to-purple-300/15 rounded-full blur-3xl"></div>

        {/* Enhanced animated light rays */}
        <div className="absolute top-0 left-1/3 w-1 h-full bg-gradient-to-b from-cyan-400/40 via-transparent to-cyan-400/40 animate-pulse shadow-lg shadow-cyan-400/30"></div>
        <div className="absolute top-0 right-1/3 w-1 h-full bg-gradient-to-b from-purple-400/40 via-transparent to-purple-400/40 animate-pulse shadow-lg shadow-purple-400/30" style={{animationDelay: '1s'}}></div>
        
        {/* Enhanced corner accent elements */}
        <div className="absolute top-0 left-0 w-32 h-32">
          <div className="absolute top-0 left-0 w-16 h-1 bg-gradient-to-r from-cyan-400/80 to-transparent shadow-md shadow-cyan-400/50"></div>
          <div className="absolute top-0 left-0 w-1 h-16 bg-gradient-to-b from-cyan-400/80 to-transparent shadow-md shadow-cyan-400/50"></div>
          <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-cyan-400/60"></div>
        </div>
        <div className="absolute bottom-0 right-0 w-32 h-32">
          <div className="absolute bottom-0 right-0 w-16 h-1 bg-gradient-to-l from-orange-400/80 to-transparent shadow-md shadow-orange-400/50"></div>
          <div className="absolute bottom-0 right-0 w-1 h-16 bg-gradient-to-t from-orange-400/80 to-transparent shadow-md shadow-orange-400/50"></div>
          <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-orange-400/60"></div>
        </div>

        {/* Additional pink glow layers */}
        <div className="absolute inset-0 bg-gradient-to-br from-pink-300/5 via-transparent to-pink-400/10 pointer-events-none"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-pink-200/5 to-transparent pointer-events-none"></div>
        
        {/* Cyberpunk data streams */}
        <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent animate-pulse"></div>
        <div className="absolute bottom-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-orange-400/50 to-transparent animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="relative inline-block mb-8">
            <div className="flex items-center justify-center space-x-3 text-orange-300 mb-4">
              <span className="text-cyan-300 opacity-90 text-lg cyberpunk-bracket-pulse shadow-lg shadow-cyan-400/30">[</span>
              <div className="relative overflow-hidden">
                <span className="text-white tracking-wider uppercase text-xl font-cyberpunk bg-gradient-to-r from-orange-300 to-cyan-300 bg-clip-text text-transparent relative z-10 cyberpunk-glow drop-shadow-lg">
                  Follow Our Cosmic Journey
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-300/30 to-transparent transform translate-x-full cyberpunk-sheen w-4 shadow-xl">
                </div>
              </div>
              <span className="text-cyan-300 opacity-90 text-lg cyberpunk-bracket-pulse shadow-lg shadow-cyan-400/30">]</span>
            </div>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-px bg-gradient-to-r from-transparent via-orange-300/80 to-transparent cyberpunk-underline"></div>
            <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-cyan-300/60 to-transparent blur-sm"></div>
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 h-px bg-gradient-to-r from-transparent via-pink-300/40 to-transparent blur-sm"></div>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="flex items-center justify-center flex-wrap gap-3 mb-8 sm:mb-12">
          <a href="https://x.com/indiegamegems" target="_blank" rel="noopener noreferrer" aria-label="Twitter"
            className="p-3 bg-slate-800/50 rounded-full border border-cyan-500/20 hover:border-cyan-500/40 hover:bg-cyan-500/10 transition-all duration-300 transform hover:scale-110">
            <svg className="h-6 w-6 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622Zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
          <a href="https://www.youtube.com/@GameGauntlet-Channel" target="_blank" rel="noopener noreferrer" aria-label="YouTube"
            className="p-3 bg-slate-800/50 rounded-full border border-cyan-500/20 hover:border-cyan-500/40 hover:bg-cyan-500/10 transition-all duration-300 transform hover:scale-110">
            <svg className="h-6 w-6 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>
          <a href="https://discord.gg/R9prqj89SV" target="_blank" rel="noopener noreferrer" aria-label="Discord"
            className="p-3 bg-slate-800/50 rounded-full border border-cyan-500/20 hover:border-cyan-500/40 hover:bg-cyan-500/10 transition-all duration-300 transform hover:scale-110">
            <svg className="h-6 w-6 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/cosmicforces/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
            className="p-3 bg-slate-800/50 rounded-full border border-cyan-500/20 hover:border-cyan-500/40 hover:bg-cyan-500/10 transition-all duration-300 transform hover:scale-110">
            <svg className="h-6 w-6 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
            </svg>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61573354887072" target="_blank" rel="noopener noreferrer" aria-label="Facebook"
            className="p-3 bg-slate-800/50 rounded-full border border-cyan-500/20 hover:border-cyan-500/40 hover:bg-cyan-500/10 transition-all duration-300 transform hover:scale-110">
            <svg className="h-6 w-6 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a href="https://www.tiktok.com/@gamegauntlet" target="_blank" rel="noopener noreferrer" aria-label="TikTok"
            className="p-3 bg-slate-800/50 rounded-full border border-cyan-500/20 hover:border-cyan-500/40 hover:bg-cyan-500/10 transition-all duration-300 transform hover:scale-110">
            <svg className="h-6 w-6 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
            </svg>
          </a>
        </div>

        {/* YouTube Videos Strip */}
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {videoData.map((video) => (
              <div
                key={video.id}
                className="group relative bg-gradient-to-br from-slate-800/40 to-slate-700/20 backdrop-blur-sm rounded-2xl border border-cyan-500/20 overflow-hidden hover:border-cyan-400/60 transition-all duration-300 cursor-pointer transform hover:scale-105 hover:shadow-2xl hover:shadow-cyan-400/20"
                onClick={() => handleVideoClick(video.url)}
              >
                {/* Thumbnail Container */}
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    onError={(e) => {
                      // Multiple fallback options for YouTube thumbnails
                      const target = e.target as HTMLImageElement;
                      const videoId = target.src.split('/')[4];
                      
                      if (target.src.includes('maxresdefault')) {
                        target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                      } else if (target.src.includes('hqdefault')) {
                        target.src = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
                      } else if (target.src.includes('mqdefault')) {
                        target.src = `https://img.youtube.com/vi/${videoId}/default.jpg`;
                      }
                    }}
                  />
                  
                  {/* Duration Badge */}
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white px-2 py-1 rounded text-xs font-cyberpunk">
                    {video.duration}
                  </div>
                  
                  {/* Play Button Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <div className="bg-cyan-500/90 backdrop-blur-sm rounded-full p-4 transform scale-75 group-hover:scale-100 transition-transform duration-300 shadow-lg shadow-cyan-400/50">
                      <Play className="h-8 w-8 text-white fill-white" />
                    </div>
                  </div>

                  {/* Neon border glow effect */}
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-cyan-400/50 rounded-lg transition-all duration-300"></div>
                </div>

                {/* Video Info */}
                <div className="p-4">
                  <h3 className="text-white text-sm font-cyberpunk leading-tight mb-2 group-hover:text-cyan-300 transition-colors duration-300 line-clamp-2">
                    {video.title}
                  </h3>
                  
                  {/* Attribution */}
                  <div className="mb-2">
                    <span className="text-cyan-300/80 text-xs font-cyberpunk tracking-wide">
                      by {video.attribution}
                    </span>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <span className="flex items-baseline space-x-1">
                      <span className="text-cyan-300 font-mono font-bold text-lg leading-none" style={{textShadow: '0 0 8px rgba(34,211,238,0.5)'}}>{video.views}</span>
                      <span className="text-gray-400 font-mono text-lg leading-none">views</span>
                    </span>
                    <ExternalLink className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-cyan-400" />
                  </div>

                  {/* Cyberpunk accent line */}
                  <div className="mt-3 h-px bg-gradient-to-r from-transparent via-cyan-400/30 to-transparent group-hover:via-cyan-400/60 transition-all duration-300"></div>
                </div>

                {/* Corner accents */}
                <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-cyan-400/0 group-hover:border-cyan-400/60 transition-all duration-300"></div>
                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-orange-400/0 group-hover:border-orange-400/60 transition-all duration-300"></div>
              </div>
            ))}
          </div>

          {/* Discord Community Section */}
          <div className="text-center mt-16">
            <div className="relative max-w-lg mx-auto">
              {/* Large Discord Logo */}
              <div className="mb-6 flex justify-center">
                <div className="relative">
                  <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm rounded-full p-6 border border-cyan-400/30 group hover:border-cyan-400/60 transition-all duration-300 hover:scale-110 transform">
                    <DiscordIcon className="h-16 w-16 text-cyan-300 hover:text-white transition-colors duration-300" />
                  </div>
                  {/* Glowing ring around Discord logo */}
                  <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/20 to-purple-400/20 rounded-full blur-lg animate-pulse"></div>
                </div>
              </div>

              {/* Community Stats & Description */}
              <div className="mb-8 space-y-4">
                <div className="flex items-center justify-center space-x-3 text-orange-300">
                  <span className="text-cyan-300 opacity-90 text-sm cyberpunk-bracket-pulse shadow-lg shadow-cyan-400/30">[</span>
                  <div className="relative overflow-hidden">
                    <span className="text-white tracking-wider uppercase text-lg font-cyberpunk bg-gradient-to-r from-orange-300 to-cyan-300 bg-clip-text text-transparent relative z-10 cyberpunk-glow drop-shadow-lg">
                      7,000+ Cosmic Explorers
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-300/30 to-transparent transform translate-x-full cyberpunk-sheen w-4 shadow-xl">
                    </div>
                  </div>
                  <span className="text-cyan-300 opacity-90 text-sm cyberpunk-bracket-pulse shadow-lg shadow-cyan-400/30">]</span>
                </div>
                
                <p className="text-cyan-200/80 text-sm font-cyberpunk leading-relaxed">
                  Join our friendly cosmic family for game updates, exclusive content, and epic space adventures
                </p>
              </div>

              {/* Join Button */}
              <a 
                href="https://discord.gg/R9prqj89SV"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-cyan-500/20 to-purple-600/20 backdrop-blur-sm rounded-full px-10 py-4 border border-cyan-400/30 group hover:border-cyan-400/60 transition-all duration-300 hover:scale-105 transform"
              >
                <div className="flex items-center space-x-3">
                  <span className="text-cyan-300 font-cyberpunk text-sm tracking-wider uppercase">
                    Join the Cosmic Community
                  </span>
                  <ExternalLink className="h-4 w-4 text-cyan-300 group-hover:text-white transition-colors duration-300" />
                </div>
              </a>

              {/* Decorative cyberpunk frame */}
              <div className="absolute inset-0 pointer-events-none">
                {/* Corner accent elements */}
                <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-cyan-400/30 group-hover:border-cyan-400/60 transition-all duration-300"></div>
                <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-cyan-400/30 group-hover:border-cyan-400/60 transition-all duration-300"></div>
                <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-orange-400/30 group-hover:border-orange-400/60 transition-all duration-300"></div>
                <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-orange-400/30 group-hover:border-orange-400/60 transition-all duration-300"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}